export default __webpack_public_path__ + "static/media/Alysse Castro.a4f46b20.jpg";